<template>
  <div class="OfficeDetalis">
    <Navigator :title="serviceChildName"></Navigator>
    <div class="dtap" v-if="detalisInfo.serviceQrcodeList">
      <QrcodeQuickEntry :serviceQrcodeList="detalisInfo.serviceQrcodeList"></QrcodeQuickEntry>
    </div>
    <div class="header">
      <div class="img_b">
        <img :src="detalisInfo.roomPic" alt="">
        <p class="tap">{{detalisInfo.roomTag}}</p>
      </div>
      <div class="text">
        <!-- <div class="icon" style="color: #777676">
          <i class="iconfont icon-dizhi">{{detalisInfo.qrcodeAddress}}</i>
        </div> -->
        <p class="title">{{detalisInfo.roomName}}</p>
        <ServiceRate :score="score" :totalScoreNum="detalisInfo.totalScoreNum" class="rate"></ServiceRate>
        <!-- <p class="price">价格：{{detalisInfo.minFee / 100 | PriceFilter}} <span class="capacity fr">容量：{{detalisInfo.capacityNum}}</span> </p> -->
        <p class="price"><span class="capacity fr">容量：{{detalisInfo.capacityNum}}</span> </p>
      </div>
    </div>

    <h3 class="title">会议室介绍</h3>
    <div class="content" v-html="detalisInfo.content" ref="text"></div>

    <div class='footer'>
      <mt-button @click='appointment(detalisInfo.id)' size="small">预 约</mt-button>
    </div>

    <!-- <div class="foot">
      <div class="submitBtn" @click="appointment(detalisInfo.id)">预约</div>
    </div> -->
  </div>

</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { Toast } from 'mint-ui';
import QrcodeQuickEntry from '@/components/QrcodeQuickEntry';

export default {
  data() {
    return{
      detalisInfo: {},
      tapText: '',
      serviceMsg: {},
      serviceChildName: '会议室详情',
      score: 0,//平均评分
    };
  },
  methods: {
    getServiceChildName() {
      const arrIndex = this.serviceMsg.children.findIndex((val) => {
        return val.type === 12;
      });
      if (arrIndex !== -1) {
        this.serviceChildName = this.serviceMsg.children[arrIndex].serviceName;
      } else {
        this.serviceChildName = '会议室出租';
      }
    },
    getInfo() {
      this.$http.post(`${this.URL_PREFIX}/app/get/meeting/room/info/detail`, {
        id: this.$route.params.roomId,
        parkId: this.currentParkId,
        qrId: this.$route.query.qrId || '',
      }, {
        headers: { token: this.token, }
      }).then((res) => {
        if(res.data.resCode === '10000') {
          this.detalisInfo = res.data.resData ? res.data.resData : [];
          this.detalisInfo.roomTag = this.detalisInfo.roomTag.replace(/,/g, ' | ');
          this.score = this.detalisInfo.totalScore/this.detalisInfo.totalScoreNum;
        } else if(res.data.resCode !== '10000') {
          Toast(res.data.resDesc);
          this.$router.replace('/index')
        } else if(Object.keys(res.data.resData).length == 0){
          Toast('会议室不存在或已被下架');
          this.$router.replace('/index')
        }
      });
    },
    appointment(roomId) {
      if(this.token == ''){
        this.$root.eventHub.$emit('login', this.$route.fullPath);
        return
      }
      this.$router.push({ path: `/business/OfficeAppointment/${roomId}`, query:this.$route.query });
    },
  },
  created() {
    if(this.parkServiceList.length) {
      this.serviceMsg = this.parkServiceList.find((val) => {
        return val.serviceFlag === 2;
      });
      this.getServiceChildName();
    }
    this.getInfo();
  },
  updated() {
    const imgs = this.$refs.text.querySelectorAll('img');
    imgs.forEach((val) => {
      val.style.maxWidth = '100%';
    });
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'parkServiceList']),
  },
}
</script>
<style lang="scss" scoped>
@import '~@scss';

.header{
  width: 100%;
  background-color: #fff;
  .img_b{
    display: block;
    width: 100%;
    height: 5.253333rem;
    border-radius: .053333rem .053333rem 0 0;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .tap{
      position: absolute;
      bottom: .266667rem;
      left: .266667rem;
      color: #fff;
      font-size: .32rem;
    }
  }
  .text{
    padding: .333333rem;
    .title{
      font-size: .453333rem;
      font-weight: bold;
    }
    .price{
      font-size: .4rem;
      color: rgb(217, 38, 44);
      margin-top: .133333rem;
      .capacity{
        font-size: .32rem;
        color: rgb(102, 102, 102);
      }
    }
  }
}
.title {
  padding: px2rem(27) px2rem(24);
  font-size: px2rem(34);
  font-weight: bold;
  border-bottom: 1px solid #fcfcfc;
  background-color: #fff;
  margin-top: px2rem(10);
}
.content{
  padding: .333333rem;
  background-color: #fff;
  min-height: 3rem;
  margin-bottom: .1333333rem;
}
.foot{
  height: 1.32rem;
  width: 100%;
  text-align: center;
  line-height: 1.32rem;
  .submitBtn{
    width: 9.146667rem;
    height: 1.04rem;
    border-radius: .133333rem;
    background-color: rgb(217, 38, 44);
    color: #fff;
    font-size: .493333rem;
    text-align: center;
    line-height: 1.04rem;
    display: inline-block;
  }
}
.fr{
  float: right;
}

.footer{
  padding: px2rem(16) px2rem(24);
  background-color: #f5f5f5;
  margin-top: .4rem;
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  bottom: 0;
  .mint-button{
    width: 100%;
    // height: 1.04rem;
    background: $color-main;
    color: #fff;
    font-size: .4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/business/components/detalis/OfficeDetalis.vue